import DeliverySacCpfCnpj from '@/model/resource/DeliverySacAttemptResponse'
import { cpfOrCnpj, datetime, phone, Schema } from 'simpli-web-sdk'
import DeliverySacAttemptResponse from '@/model/resource/DeliverySacAttemptResponse'
import Endereco from '@/model/resource/Endereco'

export default (model: DeliverySacAttemptResponse): Schema => ({

    nomeRazaoDestinatario: {
        content: model && model.destinatario.nome,
    },

    cpfCnpjDestinatario: {
        content: model && model.destinatario.cpfCnpj ? cpfOrCnpj(model.destinatario.cpfCnpj) : '',
    },

    telefoneDestinatario: {
        content: model && model.destinatario.telefone  ? phone(model.destinatario.telefone) : '',
    },

    enderecoDestinatario: {
        content: model && Endereco.stringified(model.destinatario.endereco),
    },

    emailDestinatario: {
        content: model && model.destinatario.email,
    },

    nomeTransportador: {
        content: model && model.transportador.responsavel.razaoSocial,
    },

    cnpjTransportador: {
        content: model &&  cpfOrCnpj(model.transportador.responsavel.cnpj) || '',
    },

    nomeEmbarcador: {
        content: model && model.embarcador.responsavel.razaoSocial,
    },

    cnpjEmbarcador: {
        content: model && cpfOrCnpj(model.embarcador.responsavel.cnpj) || '',
    },

    nroNotaFiscal: {
        content: model && model.nroNotaFiscal,
    },

    nroCTE: {
        content: model && model.nroCte,
    },

    dataPrevisao: {
        content: model && datetime(model.dataPrevisao),
    },

    attempt: {
        content: model.sacResponse && model.sacResponse.attempt,
    },

    status: {
        content: model.sacResponse && model.sacResponse.status || '-',
    },

    event: {
        content: model.sacResponse && model.sacResponse.event || '-',
    },

    data: {
        content: model.sacResponse && datetime(model.sacResponse.date),
    },

})
